/*
* Salla Location Component: location popup modal
* You can use these classes to target the elements in the component.
*/

.s-map {
  &-wrapper {}

  &-modal {
    &-wrapper {

    }
    &-title{

    }
    &-body{

    }
    &-map-element{

    }
    &-my-location-button{

    }
    &-submit-button{

    }
  }
  &-location{
    &-button{

    }
    &-icon{
      
    }
  }
}
